module.exports = __webpack_public_path__ + "img/commu.ea95ac3a.png";